module.exports = __webpack_public_path__ + "static/media/1POLICY31.25a8c65a.jpg";